import React from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ClassesSection from './components/ClassesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { LanguageProvider } from './context/LanguageContext';
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <LanguageProvider>
      <div className="bg-gray-900 min-h-screen text-white">
        <Navigation />
        <HeroSection />
        <AboutSection />
        <ClassesSection />
        <ContactSection />
        <Footer />
        <Analytics />
      </div>
    </LanguageProvider>
  );
}

export default App;
